export function formatDateTime() {
  const now = new Date();

  const day = now.getDate();
  const year = now.getFullYear();

  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const month = monthNames[now.getMonth()];

  let hours = now.getHours();
  const minutes = now.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12; // convert to 12-hour format

  return `${day} ${month} ${year}, ${hours}:${minutes}${ampm}`;
}
